import React, { useEffect } from "react";

export default function SelectionAll({
  medList,
  siteLang,
  setSelectedForPreview,
}) {
  useEffect(() => {
    let arr = [...medList];
    const unique = [
      ...new Map(arr.map((item) => [item["_id"], item])).values(),
    ];
    setSelectedForPreview(unique);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [medList, siteLang]);
  return <></>;
}
